import type { LinkedDocumentationItem } from 'shared/domain/issue/linkedDocumentation';
import { normalizeEntityIdentifier } from 'shared/utils/id/normalizeEntityIdentifier';
import * as issuesDb from 'serviceWorker/db/issues/issues';
import { broadcastSavedIssue } from 'serviceWorker/broadcasts/issues';
import { debugLog } from 'shared/logger/debugLog';

/** The issue's linked documentation changed: the pages showing it get the saved issue. */
export async function announceLinkedDocumentationChange(issueId: string): Promise<void> {
  await broadcastSavedIssue(issueId).catch((error: unknown) => {
    debugLog('announceLinkedDocumentationChange failed', { issueId, error });
  });
}

export async function appendLinkedDocumentationToIssueRecord(
  issueId: string,
  item: LinkedDocumentationItem
): Promise<LinkedDocumentationItem[] | undefined> {
  const issue = await issuesDb.getOne(issueId);
  if (!issue) {
    return undefined;
  }

  const linkedDocumentation = [...(issue.linkedDocumentation ?? []), item];
  await issuesDb.updateOne(issueId, { linkedDocumentation });
  return linkedDocumentation;
}

export async function removeLinkedDocumentationFromIssueRecord(
  issueId: string,
  linkedDocumentationId: string
): Promise<void> {
  const issue = await issuesDb.getOne(issueId);
  if (!issue) {
    return;
  }

  const linkedDocumentation = (issue.linkedDocumentation ?? []).filter(
    (item) =>
      normalizeEntityIdentifier(item._id) !==
      normalizeEntityIdentifier(linkedDocumentationId)
  );

  await issuesDb.updateOne(issueId, { linkedDocumentation });
}
